import { Component, Element, h, State, Prop, Watch, Method } from "@stencil/core";
import { ColorableComponent, applySchemeDelegate, setCssVariablesDelegate } from "../../common/colorable-component";
import { LinkListSchemeDefinition, LinkListSchemeName } from "./constants/linklist-types";
import { LINKLIST_SCHEME_CONFIG, LINKLIST_SCHEME_MAP } from "./constants/linklist-constants";
import { LinklistSchemeConfiguration } from "../../constants/colors";
import { BackgroundColor } from "../background/constants/background-types";
import { StyledComponent } from "../../decorators/styled-component";
// import { InitLogging } from "../../decorators/init-logging";

/**
 * @slot [unnamed] - Holds any number of eon-ui-linklist-item elements. These are also slotted and expect a single eon-ui-link as child element.
 * @slot editor - Use this to inject editor controls etc. in a CMS environment like AEM
 */
@Component({
  tag: "eon-ui-linklist",
  styleUrl: "linklist.scss",
  shadow: true
})
export class Linklist implements ColorableComponent<LinklistSchemeConfiguration<LinkListSchemeDefinition>> {
  // @InitLogging() sentryTransaction;
  schemeConfig: LinklistSchemeConfiguration<LinkListSchemeDefinition> = LINKLIST_SCHEME_CONFIG;
  schemeMap = LINKLIST_SCHEME_MAP;

  @StyledComponent() component: any;
  @Element() hostElement: HTMLEonUiLinklistElement;

  /**
   * The components active scheme. If {@link scheme} is set, it will be set to the corresponding scheme.
   * If not set, the component will try to calculate it based on the nearest enclosing background information given by inner-background attribute or eon-ui-background component.
   */
  @State() activeScheme: LinkListSchemeDefinition;

  /**
   * The name of the color scheme of the component.
   * If not set, the component will try to calculate it based on the nearest enclosing background information given by inner-background attribute or eon-ui-background component.
   */
  @Prop({ reflect: true }) scheme: LinkListSchemeName;

  componentWillLoad() {
    this.applyScheme();
  }

  componentDidLoad() {
    this.setCssVariables();
  }

  /**
   * This method can be called to re-trigger the automatic background color detection
   */
  @Method()
  async updateScheme(backgroundColor?: BackgroundColor) {
    applySchemeDelegate(this, backgroundColor);
  }

  @Watch("scheme")
  applyScheme(): void {
    applySchemeDelegate(this);
  }

  @Watch("activeScheme")
  setCssVariables(): void {
    setCssVariablesDelegate(this);
  }

  render() {
    return (
      <div>
        <slot />
        <slot name="editor" />
      </div>
    );
  }
}
